import { render, staticRenderFns } from "./PSubscriptionGuidanceForScoutModal.vue?vue&type=template&id=2327bef8&scoped=true&"
import script from "./PSubscriptionGuidanceForScoutModal.vue?vue&type=script&lang=ts&"
export * from "./PSubscriptionGuidanceForScoutModal.vue?vue&type=script&lang=ts&"
import style0 from "./PSubscriptionGuidanceForScoutModal.vue?vue&type=style&index=0&id=2327bef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327bef8",
  null
  
)

export default component.exports